export default __webpack_public_path__ + "static/media/home.8db9c00d.svg";